import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { ScreeningService } from '../services/screening.service';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { ChannelService, ChannelEvent } from '../services/channel.service';
import { ApplicantDataService } from '../services/applicant-data.service';
import { Subject, Subscription } from 'rxjs';
import { ConditionalExpr } from '@angular/compiler';

@Component({
  selector: 'app-applicant-review-waiting',
  templateUrl: './applicant-review-waiting.component.html',
  styleUrls: ['./applicant-review-waiting.component.less']
})
export class ApplicantReviewWaitingComponent implements OnInit,OnDestroy {
  ngOnDestroy(): void {
    this.sub.unsubscribe();
    this.sub2.unsubscribe();
  }
  currentProgress : number = 0;
  listner$ : Subject<any>;
  sub : Subscription;
  listner2$ : Subject<any>;
  sub2 : Subscription;
  constructor(private changes : ChangeDetectorRef,private screeningSrv: ScreeningService, private location: Router, private auth : AuthService, private toast : ToastrService, private channels : ChannelService, private applicantData : ApplicantDataService) {
    this.listner$ = this.applicantData.dataLoaded;
    this.sub = this.listner$.subscribe(()=>{
      this.currentProgress= 100;
      // this.changes.detectChanges();
      this.location.navigateByUrl('/review');
    })

    this.listner2$ = this.applicantData.inviteFetched;
    this.sub2 = this.listner2$.subscribe(()=>{
      this.applicantData.FetchApplicantData();
    })


    this.channels.sub('ResponseParserJob').subscribe((evt: ChannelEvent) => {
      // this.toast.success('Received an update from the jobs engine.');
      // console.log(evt);
      evt.data = JSON.parse(evt.data);
      // console.log(evt.data);
      this.currentProgress= this.currentProgress + 20;
      // this.changes.detectChanges();

      if(evt.data.lastRun){
        // Then set the token and send user to applicant review.
        this.applicantData.token = this.screeningSrv.screeningToken;
        this.applicantData.password = evt.data.pw;
        this.applicantData.FetchApplicantInvite();
      }
    });

    this.channels.sub('SearchProcessingJob').subscribe((evt: ChannelEvent) => {
      // this.toast.success('Received an update from the jobs engine.');
      evt.data = JSON.parse(evt.data);
      this.currentProgress= this.currentProgress + 20;
      // this.changes.detectChanges();
    });
   }

  ngOnInit() {
  }

}
